import { mountAgentioEvent } from './mountAgentioEvent';
import { AgentioEvent } from './types';

export function mountAgentioLead() {
  mountAgentioEvent({ name: AgentioEvent.Lead });
}
